module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills nav-stacked nav-bordered row"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Homepage'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Strona główna")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": _vm.recordsRoute
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Notowania")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Producers'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Kontrahenci")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Products'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Produkty")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Notices'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Ogłoszenia")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Regulations'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Regulamin")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'PriceList'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cennik")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Contact'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Kontakt")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Users'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Użytkownicy notowań")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Payments'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Płatności")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b765a86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 456
// module chunks = 1